import { render, staticRenderFns } from "./ProductCatalog.vue?vue&type=template&id=1308c59a&"
import script from "./ProductCatalog.vue?vue&type=script&lang=js&"
export * from "./ProductCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports